import { writable } from 'svelte/store';
import type { toastSizeType, toastVarientType } from '$lib/types/toastStore';

const ToastVisible = () => {
  const { subscribe, set } = writable<boolean>(false);

  return {
    subscribe,
    show: () => set(true),
    hide: () => set(false)
  };
};
const ToastHeading = () => {
  const { subscribe, set } = writable<string>('');

  return {
    subscribe,
    setToastHeading: (heading: string) => set(heading),
    reset: () => set('')
  };
};

const ToastVarient = () => {
  const { subscribe, set } = writable<toastVarientType>(undefined);

  return {
    subscribe,
    setToastVarient: (type: toastVarientType) => set(type),
    reset: () => set(undefined)
  };
};

const ToastSize = () => {
  const { subscribe, set } = writable<toastSizeType>(undefined);

  return {
    subscribe,
    setToastSize: (size: toastSizeType) => set(size),
    reset: () => set(undefined)
  };
};

const ToastRedirectURL = () => {
  const { subscribe, set } = writable<string>('');

  return {
    subscribe,
    setToastRedirectURL: (redirectURL: string) => set(redirectURL),
    reset: () => set('')
  };
};

const isToastVisible = ToastVisible();
const toastHeading = ToastHeading();
const toastVarient = ToastVarient();
const toastSize = ToastSize();
const toastRedirectURL = ToastRedirectURL();

// Toast Store Controller
const toastStoreController = (
  heading: string,
  type?: toastVarientType,
  size?: toastSizeType,
  redirectURL?: string
) => {
  isToastVisible.show();
  toastHeading.setToastHeading(heading);
  toastVarient.setToastVarient(type);
  toastSize.setToastSize(size);
  redirectURL && toastRedirectURL.setToastRedirectURL(redirectURL);
};

// Reset Toast Store
const resetToastStore = () => {
  isToastVisible.hide();
  toastHeading.reset();
  toastVarient.reset();
  toastSize.reset();
  toastRedirectURL.reset();
};

export {
  isToastVisible,
  toastHeading,
  toastVarient,
  toastSize,
  toastRedirectURL,
  resetToastStore,
  toastStoreController
};
